import ColourConverter from "@/ColourConverter"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { alpha, Chip, List, ListItem, ListItemButton, ListItemIcon, ListItemText, styled } from "@mui/material"

export const StyledList = styled(List)(({ theme }) => ({
    marginLeft: theme.spacing(6),
    padding: 0,
    borderLeft: `1px solid ${alpha(theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black, 0.12)}`
}))

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    padding: theme.spacing(0.25, 1),
    '&:hover .expandIcon': {
        opacity: 1
    },
    position: 'relative',
    ":hover": {
        cursor: 'pointer'
    }
}))

export const StyledListItem = styled(ListItem)(({ theme }) => ({
    padding: theme.spacing(0.25, 1)
}))


export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
    minWidth: theme.spacing(4)
}))

export const StyledListItemText = styled(ListItemText)(() => ({
    flex: '0 0 auto',
}))

export const StyledListItemInformationIcon = styled(ListItemIcon)(({ theme }) => ({
    minWidth: theme.spacing(4),
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: '0.5rem'
}))

export const ChipError = styled(Chip)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? ColourConverter("RedDark") : ColourConverter("RedLight"),
}));


export const IconError = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.mode === 'dark' ? ColourConverter("RedDark") : ColourConverter("RedLight"),
}));

export const InformationIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.light,
}));